"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var useDealStatusAssertion_1 = require("../../../../common/react/useDealStatusAssertion");
var VehicleSummary_1 = require("../../continueInDealership/components/vehicleSummary/VehicleSummary");
var EnquiryForm_1 = require("../../../commonSteps/enquiryForm/components/enquiryForm/EnquiryForm");
var globalTypes_1 = require("../../../../__generated__/globalTypes");
var useEnquiryNextStep_1 = require("../../common/hooks/useEnquiryNextStep");
var ReserveOnline = function () {
    var _a;
    useDealStatusAssertion_1.default((_a = {},
        _a[globalTypes_1.JourneyType.reserve_online] = 3000,
        _a[globalTypes_1.JourneyType.continue_in_dealership] = false,
        _a[globalTypes_1.JourneyType.online_order] = false,
        _a));
    var goToNextStep = useEnquiryNextStep_1.default(globalTypes_1.JourneyType.reserve_online).goToNextStep;
    return (<core_1.Container>
      <VehicleSummary_1.default />
      <EnquiryForm_1.default journeyType={globalTypes_1.JourneyType.reserve_online} goToNextStep={goToNextStep}/>
    </core_1.Container>);
};
exports.default = ReserveOnline;
